import { deleteMasterTag, getMasterTagsList } from './actions/ManageTagActions';
import { Field, reduxForm, reset } from 'redux-form';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import PaginatorCustom from './../../../../components/paginationCustom';
import ManageTagModal from './manage_tag_modal';
import RaisedButton from 'material-ui/RaisedButton';
import React from 'react';
import { renderTextField } from './../../../../components/reduxFields';
import SortingCustom from '../../../../components/SortingCustom';
import { alertConfirmation, resetFiltersAndSorting } from './../../../../actions/utilAction';
import SubString from 'add-ellipsis';
import Tooltip from '../../../../components/Tooltip';

class ManageTag extends React.Component {

  constructor(props) {
    super(props);
    this.state = ({
      open: false,
      tagId: null,
      tagObj: null,
    });

    this.filter = {
      sort_Column: '',
      sort_order: '',
      searchText: '',
    };

    this.renderManageTag = this.renderManageTag.bind(this);
    this.handleSearchTagName = this.handleSearchTagName.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  };
  componentWillMount() {
    this.loadData();
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.saved_masterTag && this.props.saved_masterTag !== nextProps.saved_masterTag) {
      this.loadData();
    }
    if (nextProps.deleted_masterTag && this.props.deleted_masterTag !== nextProps.deleted_masterTag) {
      this.loadData();
    }
  };

  componentWillUnmount() {
    Alert.closeAll();
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: { SearchText: this.filter.searchText || null },
      pageNumber: page_number || 1,
    };
    this.props.getMasterTagsList(searchObj);
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  }

  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, tagId: null, tagObj: null });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleEditClick = (event, tagObj) => {
    Alert.closeAll();
    this.setState({ open: true, tagId: tagObj.id, tagObj: tagObj });
  };

  handleAlertClick = (event, id) => {
    this.props.deleteMasterTag(id);
    Alert.closeAll();
  };

  handleDeleteClick = (event, tagObj) => {
    let warningMsg = 'Once you click yes, all the staff and clients linked with this tag will get effected. Are you sure you want to delete this tag?';
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: tagObj.id,
      },
    });
  };
  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  };
  handleSearchTagName() {
    return false;
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('ManageTagForm'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.filter.sort_Column = '';
    this.filter.sort_order = '';
    this.loadData();
  }

  renderManageTag(masterTagsList) {
    masterTagsList = masterTagsList || [];
    if (!masterTagsList.length) {
      return (
        <tr><td colSpan="6" className="text-center no-record">{this.props.loading ? 'loading please wait...' : 'No record found.'}</td></tr>
      );
    }

    return masterTagsList.map((obj, index) => {
      return (
        <tr key={index}>
          <td>{obj.tag}</td>
          <td>
            {obj.description && obj.description.length > 0 ?
              <Tooltip Description={obj.description} />
              : null}
            {obj.description && obj.description.length > 35 ? SubString(obj.description, 35) : obj.description ? obj.description : '-'}
          </td>
          <td><span className="bgcolor-circle" style={{ backgroundColor: obj.colorCode }}></span></td>
          <td><span className="bgcolor-circle" style={{ backgroundColor: obj.fontColorCode }}></span></td>
          <td>{obj.roleTypeName}</td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td>
              {
                this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null
              }
              {
                this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  }

  render() {
    const { handleSubmit, masterTagsData } = this.props;
    let masterTagsList = (masterTagsData && masterTagsData.data) || [];
    let masterTagsMeta = (masterTagsData && masterTagsData.meta) || null;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
      'suptable': true,
    });

    return (
      <div>
        {this.state.open && <ManageTagModal closeDialog={this.handleClose} tagId={this.state.tagId} tagObj={this.state.tagObj} />}
        <h2 className="page_title">Manage Tags</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className='row'>
                <div className="col-sm-5">
                  {this.props.addPermission && <RaisedButton label="Add Tag" primary={true} onTouchTap={this.handleOpen} />}
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form"
                        onSubmit={handleSubmit(this.handleSearchTagName)}>
                        <Field
                          name="TagName"
                          floatingLabelText="Search"
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                          maxLength='15'
                          fullWidth={true}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton className="grey_btn" onTouchTap={this.handleResetButton}>Reset</RaisedButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 mt-15">
                <div className="table-responsive">
                  <table className={tableClass}>
                    <thead>
                      <tr>
                        <th width="25%">
                          <SortingCustom noSort={!masterTagsList.length} setSortColumn={this.setSortColumn} columnName='Tag' displayName='Tag Name' />
                        </th>
                        <th width='35%'>
                          <SortingCustom noSort={!masterTagsList.length} setSortColumn={this.setSortColumn} columnName='Description' displayName='Description' />
                        </th>
                        <th width="10%">Color</th>
                        <th width="10%">Font Color</th>
                        <th width='10%'>Link To</th>
                        {this.props.updatePermission || this.props.deletePermission ?
                          <th width="10%">Actions</th>
                          : null
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderManageTag(masterTagsList)}
                    </tbody>
                  </table>

                </div>
                {masterTagsMeta && masterTagsMeta['totalPages'] ?
                  <PaginatorCustom data={masterTagsMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

function mapStateToProps(state) {

  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_MANAGETAGS_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_MANAGETAGS_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_MANAGETAGS_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_MANAGETAGS_LIST_DELETE')[0].permission : false;

  // End For Role Permission

  return {
    loading: state.manage_tag.loading,
    masterTagsData: state.manage_tag.masterTagsList,
    deleted_masterTag: state.manage_tag.deleted_masterTag,
    saved_masterTag: state.manage_tag.saved_masterTag,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
  };
}
ManageTag = reduxForm({
  form: 'ManageTagForm',
})(ManageTag);

export default connect(mapStateToProps, { deleteMasterTag, getMasterTagsList })(ManageTag);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/manageTags/manage_tag.js